import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { addProps, addIntlProps } from 'utils/recompose';
import {
  fetchUserSetting,
  updateUserSetting,
  toggleUserSetting,
} from 'reducers/userSetting/actions';
import { email, enabled } from 'reducers/userSetting/selectors';
import { theme } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import messages from './messages';

const mapStateToProps = combineSelectors({
  email,
  enabled,
  theme,
});

export function componentDidMount() {
  this.props.fetchUserSetting();
}

export const toggle = ({
  enabled,
  toggleUserSetting,
  removeSavedSetting,
}) => () => {
  toggleUserSetting({ enabled: !enabled });
  removeSavedSetting();
};

export const buttonStyle = ({ theme }) => ({
  backgroundColor: theme.button.enabled,
});

export const displaySavedSetting = ({ displaySettingsSavedText }) => () => ({
  displaySettingsSavedText: true,
});

export const removeSavedSetting = ({ displaySettingsSavedText }) => () => ({
  displaySettingsSavedText: false,
});

export const save = ({
  displaySavedSetting,
  enabled,
  updateUserSetting,
}) => () => {
  updateUserSetting({ enabled });
  displaySavedSetting();
};

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['settingTitle', 'saveText', 'settingUpdatedText'],
  }),
  connect(
    mapStateToProps,
    {
      fetchUserSetting,
      updateUserSetting,
      toggleUserSetting,
    },
  ),
  addProps({ buttonStyle }),
  withStateHandlers(
    {
      displaySettingsSavedText: false,
    },
    { displaySavedSetting, removeSavedSetting },
  ),
  withHandlers({ save, toggle }),
  lifecycle({ componentDidMount }),
);
